<template>
  <div class="classes-detail">
    <img class="classes-detail-cover" :src="detail.cover_image" />
    <div class="classes-detail-main">
      <div>
        <div class="classes-detail-title bold5">
          {{ detail.name }}
        </div>
        <div class="classes-detail-info">
          <span class="classes-detail-info_item">
            <span>共</span>
            <span class="classes-detail-info_count">
              <span>{{ detail.course_num }}</span>
            </span>
            <span>门课程</span>
          </span>
          <span
            v-if="detail.course_classify_name"
            class="classes-detail-info_item"
          >
            <span>{{ detail.course_classify_name }}</span>
          </span>
          <span v-if="detail.grade_name" class="classes-detail-info_item">
            <span>{{ detail.grade_name }}</span>
          </span>
          <span v-if="detail.course_name" class="classes-detail-info_item">
            <span>{{ detail.course_name }}</span>
          </span>
        </div>
        <div class="classes-detail-info">
          <span>学习有效期：</span>
          <span class="classes-detail-info_time">
            <template v-if="detail.valid_type == 1">长期有效</template>
            <template v-else>
              {{ detail.valid_time | tsFormat("yyyy/MM/dd") }}
            </template>
          </span>
        </div>
        <div class="coupon-container" v-if="couponList.length > 0">
          <div class="coupon-wrap">
            <span class="label">优惠券：</span>
            <Coupon @getCoupon="onGetCoupon" :couponList="couponList"></Coupon>
          </div>
        </div>
      </div>
      <div class="classes-detail-bottom">
        <div class="price-container">
          <CurrencyNew
            :price="detail.price"
            :priceUnderline="detail.underlined_price"
            :isUnderlineLeft="false"
            priceTwo
          ></CurrencyNew>
        </div>
        <div class="btn-wrap">
          <a
            v-if="detail.has_buy"
            @click="goToStudy"
            class="btn btn-warning"
            :class="
              detail.valid_type != 1 && detail.valid_time < nowDate
                ? 'disabled'
                : ''
            "
          >
            {{
              detail.valid_type != 1 && detail.valid_time < nowDate
                ? "已过期"
                : "立即学习"
            }}
          </a>
          <template v-else-if="detail.status == 1">
            <a
              class="btn btn-primary"
              :class="{
                'btn-disabled': isSoldOut || detail.buy_online_switch == 2,
              }"
              @click="onBuy"
            >
              {{
                detail.buy_online_switch == 2
                  ? "联系客服报名"
                  : isSoldOut
                  ? "已售罄"
                  : "立即报名"
              }}
            </a>
          </template>
          <span class="sales_num">{{ detail.student_num }}人已报名</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Coupon from "../Coupon.vue";

export default {
  name: "ClassesDetailInfo",
  components: { Coupon },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
    couponList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      nowDate: Date.now() / 1000,
    };
  },
  computed: {
    isSoldOut() {
      return this.detail.compilation_num <= this.detail.sales_num;
    },
  },
  methods: {
    onGetCoupon(id) {
      this.$emit("getCoupon", id);
    },
    async onBuy() {
      if (this.detail.buy_online_switch == 2) {
        return;
      }
      if (this.isSoldOut) {
        this.$alert("你来晚了哦,名额已经没有了", "提示");
        return;
      }
      let obj = {
        shop_id: this.detail.id,
        shop_type: 19,
        coupon_id: 0,
        product_number: 1,
      };
      this.$router.push({
        name: "OrderConfirm",
        params: {
          id: this.detail.id,
        },
        query: {
          type: 19,
          order_type: 1,
          shop_infos: JSON.stringify([obj]),
        },
      });
    },
    goToStudy() {
      this.$router.push({
        name: "MemberClassesDetail",
        params: { id: this.detail.min_class_id }, //小班id
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.classes-detail {
  background: #ffffff;
  border-radius: 4px;
  padding: 24px;
  display: flex;
}
.classes-detail-cover {
  width: 420px;
  height: 280px;
  border-radius: 5px;
  margin-right: 24px;
}
.classes-detail-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.classes-detail-title {
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Medium;
  line-height: 25px;
  margin-bottom: 8px;
}
.classes-detail-info {
  color: #999999;
  margin-bottom: 8px;
}
.classes-detail-info_item {
  position: relative;
  margin-right: 21px;

  &::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 16px;
    top: 2px;
    right: -10px;
    background: #cccccc;
  }

  &:last-child::after {
    display: none;
  }
}
.classes-detail-info_count {
  color: #666666;
  margin: 0 4px;
}
.classes-detail-info_time {
  color: #666;
}
.coupon-container {
  background: #fafafa;
  border-radius: 2px;
  padding: 17px 0 0 10px;
  margin-top: 18px;
}
.coupon-wrap {
  display: flex;
  align-items: flex-start;

  .label {
    flex-shrink: 0;
    color: #999999;
    font-size: 14px;
    margin-right: 22px;
  }

  /deep/ {
    .coupon-wrap {
      position: static;
    }
  }
}
.price-container {
  display: flex;
  align-items: center;

  /deep/ {
    .price-wrap {
      justify-content: flex-start;

      .price {
        font-size: 24px;
        margin-right: 8px;

        .rmb-svg-new {
          margin-right: 2px;
        }
      }

      .price-underline {
        padding-bottom: 2px;

        .rmb-svg-new {
          display: flex;
        }
      }
    }
  }
}
.btn-wrap {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.btn {
  width: 148px;
  height: 40px;
  background: $primary-color;
  border-radius: 20px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  &:hover {
    background: linear-gradient(90deg, $primary-color-8, $primary-color);
  }
}

.btn-disabled {
  background: #bfbfbf;
  color: white;
  cursor: not-allowed;

  &:hover {
    background: #bfbfbf;
  }
}

.sales_num {
  color: #666666;
  margin-left: 24px;
}
.disabled {
  background-color: #ddd;
  pointer-events: none;
}
</style>
